import React, { useCallback } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { FiFile } from 'react-icons/fi'
import { format } from 'date-fns'

import Yup from '../../../../../services/yup'
import { api, authHeaders } from '../../../../../services/api'

import { downloadRelatorioJasper } from '../../../../../util/file'

import {
    Button, Calendar
} from '../../../../../components/Form'
import Spinner from '../../../../../components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeCalendarGif from '../../../../../assets/images/gifs/periodo-dias.gif'

const initialValues = {
    pagamento: ''
}

const validation = Yup.object().shape({
    pagamento: Yup.string().nullable()
})

const nomeRelatorio = 'Relatório de Fornecedores com pendências'

export default function (props) {
    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const { pagamento } = values

        const [inicio, fim] = pagamento

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioPendenciaFornecedor',
                parametros: {
                    dataInicio: inicio ? format(new Date(inicio), 'yyyy-MM-dd') : null,
                    dataFim: fim ? format(new Date(fim), 'yyyy-MM-dd') : null
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })
            
            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch(e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, resetForm 
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>
                        
                        <Calendar 
                            name="pagamento" 
                            label="Periodo de busca"
                            maxDate={new Date()}
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeCalendarGif}" style="width:300px; height:auto" />`}
                        />

                        <Spinner
                            visible={isSubmitting} 
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>
                            
                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
